import script from "./GetYourQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./GetYourQuote.vue?vue&type=script&setup=true&lang=js"

import "./GetYourQuote.vue?vue&type=style&index=0&id=5184d363&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5184d363"]])

export default __exports__